import ListSetting from "./ListSetting.vue";
import TextSetting from "./TextSetting.vue";
import KeypadSetting from "./KeypadSetting.vue";
import KeypadToggleSetting from "./KeypadToggleSetting.vue";
import KeypadAirAvailSetting from "./KeypadAirAvailSetting.vue";
import KeypadThermostatSetpointSetting from "./KeypadThermostatSetpointSetting.vue";
import PasswordSetting from "./PasswordSetting.vue";
import IpAddressSetting from "./IpAddressSetting.vue";
import DateAndTimeSetting from "./DateAndTimeSetting.vue";
import CompanyNameSetting from "./CompanyNameSetting.vue";
import SiteNameSetting from "./SiteNameSetting.vue";
import ChannelAssignmentsSetting from "./ChannelAssignmentsSetting.vue";
import BasicStatus from "./BasicStatus.vue";
import AggregateStatus from "./AggregateStatus.vue";
import AggregateAlarms from "./AggregateAlarms.vue";
import AggregateAlarm from "./AggregateAlarm.vue";
import SensorStatus from "./SensorStatus.vue";
import ThermostatStatus from "./ThermostatStatus.vue";
import AnalogOutputStatus from "./AnalogOutputStatus.vue";
import AccFanTimeStatus from "./AccFanTimeStatus.vue";
import OperationModeStatus from "./OperationModeStatus.vue";
import ModeTimeStatus from "./ModeTimeStatus.vue";
import PushNotificationStatus from "./PushNotificationStatus.vue";
import PopoverButton from "./PopoverButton.vue";
import PlaceholderCell from "./PlaceholderCell.vue";

export default function initCellComponents(app) {
  app.component("ListSetting", ListSetting);
  app.component("TextSetting", TextSetting);
  app.component("KeypadSetting", KeypadSetting);
  app.component("KeypadToggleSetting", KeypadToggleSetting);
  app.component("KeypadAirAvailSetting", KeypadAirAvailSetting);
  app.component("KeypadThermostatSetpointSetting", KeypadThermostatSetpointSetting);
  app.component("PasswordSetting", PasswordSetting);
  app.component("IpAddressSetting", IpAddressSetting);
  app.component("DateAndTimeSetting", DateAndTimeSetting);
  app.component("CompanyNameSetting", CompanyNameSetting);
  app.component("SiteNameSetting", SiteNameSetting);
  app.component("ChannelAssignmentsSetting", ChannelAssignmentsSetting);
  app.component("BasicStatus", BasicStatus);
  app.component("AggregateStatus", AggregateStatus);
  app.component("AggregateAlarms", AggregateAlarms);
  app.component("AggregateAlarm", AggregateAlarm);
  app.component("SensorStatus", SensorStatus);
  app.component("ThermostatStatus", ThermostatStatus);
  app.component("AnalogOutputStatus", AnalogOutputStatus);
  app.component("AccFanTimeStatus", AccFanTimeStatus);
  app.component("OperationModeStatus", OperationModeStatus);
  app.component("ModeTimeStatus", ModeTimeStatus);
  app.component("PushNotificationStatus", PushNotificationStatus);
  app.component("PopoverButton", PopoverButton);
  app.component("PlaceholderCell", PlaceholderCell);
}